import cn from "classnames";

import gcImportImage from "./images/gcImport.png";
import Styles from "./Image.module.scss";

interface Props {
  className?: string;
  source?: string;
  roundedCircle?: boolean;
  altText?: string;
  onError?: () => void;
}

export const Image = ({
  source = "",
  roundedCircle = false,
  className = "",
  altText = "",
  onError,
}: Props) => {
  const classes = cn(className, roundedCircle && Styles["circle"]);
  return <img className={classes} src={source} alt={altText} onError={onError} />;
};

Image.GCImportImage = (props: Omit<Props, "source">) =>
  Image({ ...props, source: gcImportImage, altText: "GC Import" });
